import React, { useState, useEffect } from "react";

const EmployeeForm = ({
  addEmployee,
  editingEmployee,
  updateEmployee,
  cancelEditing,
}) => {
  const [name, setName] = useState("");
  const [position, setPosition] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  // Şirketteki pozisyon listesi
  const positions = [
    "Yazılım Geliştirici",
    "Proje Yöneticisi",
    "İnsan Kaynakları Müdürü",
    "Pazarlama Müdürü",
    "Satış Temsilcisi",
    "Muhasebe Müdürü",
    "Veri Analisti",
    "Sistem Yöneticisi",
    "Ürün Müdürü",
    "Tasarımcı",
    "Kalite Güvence Mühendisi",
    "Eğitim Koordinatörü",
  ];

  // Eğer güncelleme butonuna basıldıysa form alanlarını doldur
  useEffect(() => {
    if (editingEmployee) {
      setName(editingEmployee.name);
      setPosition(editingEmployee.position);
      setEmail(editingEmployee.email);
    } else {
      setName("");
      setPosition("");
      setEmail("");
    }
    setErrors({});
  }, [editingEmployee]);

  // Email validasyonu
  const validateEmail = (emailValue) => {
    return emailValue.includes("@") && emailValue.includes(".");
  };

  // Form validasyonu
  const validateForm = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = "Ad Soyad zorunludur";
    }
    if (!email.trim()) {
      newErrors.email = "E-posta zorunludur";
    } else if (!validateEmail(email)) {
      newErrors.email =
        "Geçerli bir e-posta adresi giriniz (@ işareti içermeli)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    if (editingEmployee) {
      updateEmployee({ id: editingEmployee.id, name, position, email });
    } else {
      addEmployee({ id: Date.now(), name, position, email });
    }
    setName("");
    setPosition("");
    setEmail("");
    setErrors({});
  };

  const handleCancel = () => {
    setName("");
    setPosition("");
    setEmail("");
    setErrors({});
    cancelEditing();
  };

  return (
    <div className="card p-4 mb-4 shadow-lg border-0 form-card">
      <h4 className="mb-4 text-primary">
        {editingEmployee ? "Personel Güncelle" : "Yeni Personel Ekle"}
      </h4>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <input
            className={`form-control ${errors.name ? "is-invalid" : ""}`}
            placeholder="Ad Soyad *"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          {errors.name && (
            <div className="invalid-feedback d-block">{errors.name}</div>
          )}
        </div>
        <div className="mb-3">
          <select
            className="form-control"
            value={position}
            onChange={(e) => setPosition(e.target.value)}
          >
            <option value="">Pozisyon Seçiniz</option>
            {positions.map((pos) => (
              <option key={pos} value={pos}>
                {pos}
              </option>
            ))}
          </select>
        </div>
        <div className="mb-3">
          <input
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
            placeholder="E-posta *"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {errors.email && (
            <div className="invalid-feedback d-block">{errors.email}</div>
          )}
        </div>
        <div className="d-grid gap-2">
          <button
            type="submit"
            className={`btn ${editingEmployee ? "btn-warning" : "btn-success"} btn-lg`}
          >
            {editingEmployee ? "Değişiklikleri Kaydet" : "Kaydet"}
          </button>
          {editingEmployee && (
            <button
              type="button"
              className="btn btn-secondary btn-lg"
              onClick={handleCancel}
            >
              Vazgeç
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default EmployeeForm;
